import CustomButton from "../../../../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../../helpers/apiHelper";
import SvgIcon from "../../../../../../helpers/SvgIcon";
import {
  fetchCargoCar,
  postFinishDelivery,
} from "../../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { CargoNodeDataInterface } from "../../../../../../redux/interfaces/raports.interface";

function CargoActionButton({
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const { id_transport_marfa, id_bin, id_colet, id_auto } = crudData;

  const handleFinishDelivery = async () => {
    const { page, rowsPerPage } = tableContext.tablePagination;

    const tryFinish = async (payload: {
      id_transport_marfa?: number;
      id_bin?: number;
      id_colet?: number;
    }) => {
      const resultAction = await dispatch(postFinishDelivery(payload));
      if (
        checkEndpointStatus(resultAction, postFinishDelivery) ===
          endpointStatus.fulfilled &&
        page &&
        rowsPerPage
      ) {
        dispatch(
          fetchCargoCar({
            page,
            perPage: rowsPerPage,
            idAuto: id_auto,
          }),
        );
      }
    };

    if (id_bin) {
      await tryFinish({ id_transport_marfa, id_bin });
    } else if (id_colet) {
      await tryFinish({ id_transport_marfa, id_colet });
    }
  };

  const modalSubtitleWithBin = `Esti sigur ca doresti finalizarea livrarii pentru binul ${crudData.sn_bin}?`;
  const modalSubtitleWithAwb = `Esti sigur ca doresti finalizarea livrarii pentru coletul ${crudData.doc_trans}?`;

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Finalizeaza livrarea"
        withConfirmationModal={{
          modalTitle: "Finalizare livrare",
          modalSubtitle: id_bin ? modalSubtitleWithBin : modalSubtitleWithAwb,
          modalLeftButtonVariant: "outlined",
          modalRightButtonOnClick: handleFinishDelivery,
        }}>
        <SvgIcon type="DELIVERED_AWB" fill="white" />
      </CustomButton>
    </div>
  );
}

export default CargoActionButton;
